package repdb

import androidx.paging.PagingSource
import com.ustadmobile.door.DoorDatabaseRepository
import com.ustadmobile.door.entities.DoorNode
import com.ustadmobile.door.replication.withRepoChangeMonitor
import com.ustadmobile.door.replication.withRepoChangeMonitorAsync
import com.ustadmobile.door.room.RoomDatabase
import io.ktor.client.HttpClient
import kotlin.Int
import kotlin.Long
import kotlin.String
import kotlin.Suppress
import kotlin.collections.List
import kotlinx.coroutines.flow.Flow

@Suppress("REDUNDANT_PROJECTION", "LocalVariableName", "ClassName")
public class RepDao_Repo(
  public val _db: RoomDatabase,
  public val _repo: DoorDatabaseRepository,
  public val _dao: RepDao,
  public val _httpClient: HttpClient,
  public val _clientId: Long,
  public val _endpoint: String,
) : RepDao {
  override suspend fun insertDoorNodeAsync(node: DoorNode) {
    _repo.withRepoChangeMonitorAsync("DoorNode") {
      _dao.insertDoorNodeAsync(node)
    }
  }

  override fun insertDoorNode(node: DoorNode) {
    _repo.withRepoChangeMonitor("DoorNode") {
      _dao.insertDoorNode(node)
    }
  }

  override suspend fun insertAsync(repEntity: RepEntity): Long {
    val _result = _repo.withRepoChangeMonitorAsync("RepEntity") {
      _dao.insertAsync(repEntity)
    }
    return _result
  }

  override fun insert(repEntity: RepEntity): Long {
    val _result = _repo.withRepoChangeMonitor("RepEntity") {
      _dao.insert(repEntity)
    }
    return _result
  }

  override fun insertList(repEntityList: List<RepEntity>) {
    _repo.withRepoChangeMonitor("RepEntity") {
      _dao.insertList(repEntityList)
    }
  }

  override fun update(repEntity: RepEntity) {
    _repo.withRepoChangeMonitor("RepEntity") {
      _dao.update(repEntity)
    }
  }

  override suspend fun updateAsync(repEntity: RepEntity) {
    _repo.withRepoChangeMonitorAsync("RepEntity") {
      _dao.updateAsync(repEntity)
    }
  }

  override fun countEntities(): Int {
    val _result = _dao.countEntities()
    return _result
  }

  override fun findByUid(uid: Long): RepEntity? {
    val _result = _dao.findByUid(uid)
    return _result
  }

  override suspend fun findByUidAsync(uid: Long): RepEntity? {
    val _result = _dao.findByUidAsync(uid)
    return _result
  }

  override suspend fun findAllAsync(): List<RepEntity> {
    val _result = _dao.findAllAsync()
    return _result
  }

  override suspend fun insertHttp(entity: RepEntity): Long {
    val _result = _repo.withRepoChangeMonitorAsync("RepEntity") {
      _dao.insertHttp(entity)
    }
    return _result
  }

  override suspend fun selectSyncNodeId(): Long {
    val _result = _dao.selectSyncNodeId()
    return _result
  }

  override suspend fun findInStringList(strList: List<String>): List<RepEntity> {
    val _result = _dao.findInStringList(strList)
    return _result
  }

  override suspend fun sqliteOnlyFun(num1: Int, num2: Int): Long {
    val _result = _dao.sqliteOnlyFun(num1, num2)
    return _result
  }

  override fun findAllAsFlow(): Flow<List<RepEntity>> {
    val _result = _dao.findAllAsFlow()
    return _result
  }

  override fun findAllPaged(): PagingSource<Int, RepEntity> {
    val _result = _dao.findAllPaged()
    return _result
  }

  public override fun interfaceInsertFun(entity: RepEntity) {
    _repo.withRepoChangeMonitor("RepEntity") {
      _dao.interfaceInsertFun(entity)
    }
  }
}
